import { axiosInstance } from '../../utils/fetcher';
import { API } from '../../api';

const CancelToken = axiosInstance.CancelToken;

export const getCarriersByCustomerEffect = (params) => {
  return axiosInstance.request({
    url: `${API.POV}/GetCarrier`,
    method: 'get',
    params,
  });
};

export const getAccessorialsListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentAccessorials`,
    method: 'get',
    params,
  });
};

let rateEnginCancelToken = () => {};
export const getRateShopRateResultsEffect = (data) => {
  rateEnginCancelToken();
  return axiosInstance.request({
    baseURL: `${API.BASE_ORIGIN}/rateengine/rateall`,
    method: 'post',
    data,
    cancelToken: new CancelToken(function executor(c) {
      rateEnginCancelToken = c;
    }),
  });
};
